<template>
    <section class="section" id="services">
        <div class="container">
            <div class="row justify-content-center mb-5">
                <div class="col-lg-7 text-center">
                    <h2 class="fw-bold">서비스 안내</h2>
                    <p class="text-muted">마이파랑은 쇼핑몰 판매자들의 판매를 돕기 위해 다양한 서비스를 제공합니다.</p>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="service-box text-center px-4 py-5 position-relative mb-4 btn"  v-on:click="topc4">
                        <div class="service-box-content p-4">
                            <div class="icon-mono service-icon avatar-md mx-auto mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                            </div>
                            <h4 class="mb-3 font-size-22">개인통관고유부호</h4>
                            <p class="text-muted mb-0">개인통관고유부호의 유효성을 검증할 수 있습니다. 사용법이 쉽고 간단하며, 한 번에 여러건 검증도 가능합니다.</p>
                        </div>
                    </div>
                </div>
                <!-- end col -->

                <div class="col-lg-4">
                    <div class="service-box text-center px-4 py-5 position-relative mb-4 btn" v-on:click="toshopdata">
                        <div class="service-box-content p-4">
                            <div class="icon-mono service-icon avatar-md mx-auto mb-4" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
                            </div>
                            <h4 class="mb-3 font-size-22">네이버쇼핑 순위</h4>
                            <p class="text-muted mb-0">네이버쇼핑 상품에 대한 키워드들의 순위를 확인할 수 있습니다. 일 단위로 조회 가능하며, 순위변동도 볼 수 있습니다.</p>
                        </div>
                    </div>
                </div>
                <!-- end col -->

                <div class="col-lg-4">
                    <div class="service-box text-center px-4 py-5 position-relative mb-4 btn" v-on:click="toadmanager">
                        <div class="service-box-content p-4">
                            <div class="icon-mono service-icon avatar-md mx-auto mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-server"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line></svg>
                            </div>
                            <h4 class="mb-3 font-size-22">인스타그램 마케팅</h4>
                            <p class="text-muted mb-0">스마트스토어 브랜드을 위해 꼭 해야하는 인스타 쇼핑태그 승인 샵연동을 지원합니다.</p>
                        </div>
                    </div>
                </div>
                
                <!-- end col -->
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->

    </section>
    <!-- Services end -->

</template>

<script>

export default {
    methods: {
        
        topc4: function () {
            this.$router.push('/main/pc4')
        },
        toshopdata: function () {
            this.$router.push('/main/rank')
        },
        toadmanager: function () {
            this.$router.push('/main/insta')
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/main/Main.vue